import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDown, ChevronUp } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { PDFCurrentPageInput } from "~/components/AssetModal/Visualizer/PDFVisualizer/PDFControls/components/PDFCurrentPageInput";
export const PDFPageControls = /*#__PURE__*/ memo((param)=>{
    let { currentPage, totalPages, goToPage, onFocusChange } = param;
    if (!currentPage || !totalPages) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "absolute left-1/2 top-0 flex h-full -translate-x-1/2 items-center justify-center gap-1",
        children: [
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                className: "disabled:bg-transparent disabled:text-grey-8",
                color: "grey",
                disabled: currentPage === 1,
                icon: ChevronUp,
                label: "Page up",
                onClick: ()=>goToPage(currentPage - 1),
                size: "small"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center whitespace-nowrap text-12 font-semibold text-grey-12",
                children: [
                    /*#__PURE__*/ _jsx(PDFCurrentPageInput, {
                        onFocusChange: onFocusChange,
                        currentPage: currentPage,
                        onGoToPage: goToPage,
                        totalPages: totalPages
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: " / ".concat(totalPages)
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                className: "disabled:bg-transparent disabled:text-grey-8",
                color: "grey",
                disabled: currentPage === totalPages,
                icon: ChevronDown,
                label: "Page down",
                onClick: ()=>goToPage(currentPage + 1),
                size: "small"
            })
        ]
    });
});
PDFPageControls.displayName = "PDFPageControls";
